/**
 * @description Various modal names used in the enterprise modal manager.
 */
export const ENTERPRISE_MODAL_NAMES = {
  PROGRAM_ACCESS: 'PROGRAM_ACCESS',
  LOGIN: 'LOGIN',
  PRODUCT_DESCRIPTION_PAGE_REDIRECT: 'PRODUCT_DESCRIPTION_PAGE_REDIRECT',
  AUTOENROLLED_COURSES: 'AUTOENROLLED_COURSES',
  ADD_EMAIL: 'ADD_EMAIL',
  ENTERPRISE_TERMS_OF_USE: 'ENTERPRISE_TERMS_OF_USE',
  PROGRAM_JOIN_ERROR: 'PROGRAM_JOIN_ERROR',
} as const;
